var _style, _rect, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireSensorAutomaticFireSensor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.6,
    className: "st0",
    width: 15,
    height: 15
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.9,
    y1: 5.2,
    x2: 7.9,
    y2: 8.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.9,
    y1: 10.1,
    x2: 7.9,
    y2: 10.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireSensorAutomaticFireSensor);
export default __webpack_public_path__ + "static/media/FireSensorAutomaticFireSensor.e39066d6b81791cd698ad76d2cb960d2.svg";
export { ForwardRef as ReactComponent };